/**
 * External dependencies
 */
import React from "react";
import { Text } from "components/text";

/**
 * Internal dependencies
 */

/**
 * Style dependencies
 */
import "./styles.scss";

const SettingRow = ({ label, altDescription, children }: any) => {
  return (
    <div className="flex p-6">
      <div className="settings-row__label-container">
        <Text variant="bodyMd" fontWeight="semiBold">
          {label}
        </Text>
      </div>
      <div>
        <div>{children}</div>
        <div className="mt-4">
          <Text variant="explanation">{altDescription}</Text>
        </div>
      </div>
    </div>
  );
};

SettingRow.defaultProps = {};

export default SettingRow;
